import React from 'react';
import { IAppRecommendData, IAppSearchData } from '@umu/umu-types';
import {
    SearchRange,
    SearchInputForContentInputType,
} from '@umu/umu-search/src/searchInputForContent/common/interface';

import SearchInputForContentBaseOfUmuNormal from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/umu/normal/searchInputForContentBaseOfUmuNormal';
import SearchInputForContentBaseOfUseNormal from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/use/normal/searchInputForContentBaseOfUseNormal';
import SearchInputForContentBaseOfUmuMicroPage from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/umu/microPage/searchInputForContentBaseOfUmuMicroPage';
import SearchInputForContentBaseOfUseMicroPage from '@umu/umu-search/src/searchInputForContent/common/components/searchInputForContentBase/use/microPage/searchInputForContentBaseOfUseMicroPage';

type SearchInputForContentBaseProps = {
    inputType: string;
    // Common Input 参数
    isHiddenSearchIcon?: boolean;
    placeholder?: string;
    fontSize?: number;
    disabled?: boolean;
    searchKeyword?: string;
    showFloatingLayer: boolean;
    defaultFloatValue: boolean;
    recommendData: IAppRecommendData;
    searchCallback?(keywords: string): void;
    cleanCallback(): void;
    searchInputOnFocus?(): void;
    clickCallback?(data: IAppSearchData, key: string): void;
    onChange?(keywords: string): void;
    onClearBtnClick?(): void;
    searchInputCallback?(keywords: string): void;
    searchInputClearCallback?: () => void;

    // MicroPage Input 参数
    isLogin?: boolean;
    isInIframe?: boolean;
    searchRange?: SearchRange;
    isEnterpriseAccount?: boolean;
    changeSearchRange?: (searchRange: SearchRange, keyword: string) => void;
};

function SearchInputForContentBase(props: SearchInputForContentBaseProps) {
    const { inputType, searchRange = SearchRange.currentPage } = props;

    const renderSearchInputForContentBase = (_inputType: string) => {
        switch (_inputType) {
            case SearchInputForContentInputType.umuCommon:
                return <SearchInputForContentBaseOfUmuNormal {...props}></SearchInputForContentBaseOfUmuNormal>;
            case SearchInputForContentInputType.umuMicroPage:
                return <SearchInputForContentBaseOfUmuMicroPage {...props} searchRange={searchRange} />;
            case SearchInputForContentInputType.useCommon:
                return <SearchInputForContentBaseOfUseNormal {...props} />;
            case SearchInputForContentInputType.useMicroPage:
                return <SearchInputForContentBaseOfUseMicroPage {...props} searchRange={searchRange} />;
            default:
                return null;
        }
    };

    return <div className="umu-search-input-for-content-base">{renderSearchInputForContentBase(inputType)}</div>;
}

export default SearchInputForContentBase;
